import { LoaderCircle } from "lucide-react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../auth";

export function AuthGate() {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <main className="center-stage"><LoaderCircle className="spin" aria-label="Loading" /></main>;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  return <Outlet />;
}
